import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CUPCAKE_ORDER_PATH, STANDARD_CAKE_ORDER_PATH } from './cakeorderform/utils/orderFormLinks';
import axios from 'axios';
import SavvytronFooter from '../components/SavvytronFooter'; // Adjust path if needed


const CustomerHome = () => {
  const navigate = useNavigate();
  const [isOrderingEnabled, setIsOrderingEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  const SERVER_URL = process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_SERVER_URL_LOCAL
    : process.env.REACT_APP_SERVER_URL;

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const { data } = await axios.get(`${SERVER_URL}/api/settings/order-status`);
        setIsOrderingEnabled(data.isOrderingEnabled);
      } catch (err) {
        console.error('Failed to fetch order status', err);
        setIsOrderingEnabled(true);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [SERVER_URL]);

  return (
    <div className="min-h-dvh flex flex-col bg-candy-background px-4 py-10">
      <div className="flex-1 flex flex-col items-center justify-center w-full">
      <h1 className="text-4xl sm:text-5xl font-hobo text-candy-text mb-6 text-center">
        Candy Haven
      </h1>

      <div className="w-full max-w-md bg-white rounded-2xl shadow-md p-6 sm:p-8 text-center border border-candy-border">
        <p className="text-gray-700 text-base sm:text-lg mb-6">
          Custom cakes made with love, just for you.
        </p>

        <img
          src="https://cdn-icons-png.flaticon.com/512/2454/2454297.png"
          alt="Cake"
          className="h-20 w-20 sm:h-24 sm:w-24 mx-auto mb-6"
        />

        {loading ? (
          <p className="text-candy-primary font-medium">Checking order availability...</p>
        ) : isOrderingEnabled ? (
          <div className="flex flex-col gap-3 w-full">
            <button
              type="button"
              onClick={() => navigate(STANDARD_CAKE_ORDER_PATH)}
              className="bg-candy-primary hover:bg-candy-primaryDark text-white font-semibold px-6 py-3 rounded-md w-full"
            >
              Order Standard Cakes
            </button>
            <Link
              to={CUPCAKE_ORDER_PATH}
              className="inline-block bg-white border-2 border-candy-primary text-candy-primary hover:bg-red-50 font-semibold px-6 py-3 rounded-md w-full transition"
            >
              Order Cupcakes
            </Link>
          </div>
        ) : (
          <p className="text-red-600 font-semibold">⚠️ Currently not accepting orders</p>
        )}
      </div>
      </div>
      <SavvytronFooter />

    </div>

  );
};

export default CustomerHome;
